import React, { useRef } from 'react';
import CustomCard from '../../../../Util/CustomCard';
import { Dialog } from "primereact/dialog";
import { useDialogIsolation } from "../../../../Util/useDialogIsolation";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { columnProps, tablePassThrough, useTableScrollRegion } from "../../../../Util/dataTable";

// The dialog's table. Its own component (ticket 16) so that its scroll-region hook runs once the table is on screen: the
// dialog renders its content only while it is open, after the dialog itself has mounted.
const HistoryTable = ({ history }) => {
  // RCMC-04 (ticket 16): the table's region is a Tab stop while the table is too wide for it
  const dt = useRef(null);
  useTableScrollRegion(dt);
  return (
    <DataTable
      ref={dt}
      value={history}
      paginator
      rows={10}
      stripedRows
      size="small"
      tableStyle={{ fontSize: "14px" }} // RCMC-04 (ticket 16): no fixed 50rem minimum; too wide, it scrolls in its region
      // RCMC-10 (ticket 13), as the page tables: valid row groups, scoped headers, no clickable rows. Inside a dialog
      // there is no page heading to point at, so the table (and its region, ticket 16) takes the dialog's title as its name
      pt={tablePassThrough({ label: "Status History" })}
    >
      <Column field="status_display" {...columnProps("Status", { sortable: true })} body={(request) => <div style={{whiteSpace:"nowrap"}}>{request.status_display}</div>}></Column>
      <Column field="last_updated_on" {...columnProps("Updated On", { sortable: true })}></Column>
      <Column field="last_updated_by" {...columnProps("Updated By", { sortable: true })}></Column>
    </DataTable>
  );
};

const StageHistory = (props) => {
  // RCMC-23: page behind inert while open, focus to the first field; RCMC-02: named close button
  const historyDialogIsolation = useDialogIsolation(props.isStageHistoryVisible, "Status History");
  return (
    // RCMC-04 (ticket 16): v1.2 sized this dialog by its table's fixed 50rem minimum (plus the content's 20px padding
    // each side). The table has no minimum now, so the dialog keeps that width itself: unchanged at desktop. On a window
    // narrower than that (v1.2 cut both edges off, the close button too) it stops 10px short of each edge; below 768px
    // every dialog takes the window's width (static/prime-react-custom.css). The table scrolls in its region if it must.
    <Dialog header="Status History" visible={props.isStageHistoryVisible} style={{ width: "calc(50rem + 40px)", maxWidth: "calc(100% - 20px)" }} onHide={() => {props.setIsStageHistoryVisible(false);}} {...historyDialogIsolation}>
        <HistoryTable history={props.selectedRequest.status_history} />
    </Dialog>
  )
}

export default StageHistory
